import { render, staticRenderFns } from "./BannersSection.vue?vue&type=template&id=63a98630&scoped=true&lang=pug"
import script from "./BannersSection.vue?vue&type=script&lang=ts"
export * from "./BannersSection.vue?vue&type=script&lang=ts"
import style0 from "./BannersSection.vue?vue&type=style&index=0&id=63a98630&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a98630",
  null
  
)

export default component.exports